import LazyLoad from "react-lazyload";
import Breadcrumb from "../Component/Breadcrumb";
import Footer from "../Component/Footer";
import Header from "../Component/Header";
import Menu from "../Component/Menu";
import PageTitle from "../Component/PageTitle";

const Bondingwithparents = () => {
  const homeMenu = [
    // { label: "Admission Notification ", link: "/howtoapply" },
    { label: "Fee Structure", link: "/feestructure" },
    { label: "Prospectus ", link: "/Prospectus" },
    {
      label: "Virtual School Tour ",
      link: "https://iviewd.com/lotus_valley_gurgaon/",
    },
    { label: "School Schedule ", link: "/schoolSchedule" },
    {
      label: "Transport",
      link: "",
      subMenu: [
        { label: "Transport", link: "/transport" },
        { label: "Bus Routes", link: "/busRoute" },
      ],
    },

    { label: "Special Education", link: "/specialEdu" },
    { label: "Bonding With Parents", link: "/bondingwithparents" },
    // { label: "Career Counselling", link: "/careerCounselling" },
    {
      label: "Meal Menu",
      link: "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/School-Menu.pdf",
    },
    { label: "CBSE Results", link: "/CBSEResult" },
    { label: "Transfer Certificate", link: "/tc" },
  ];
  return (
    <>
      <Header />
      <Breadcrumb breadImage="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/banner-bonding-with-parents.jpg" />
      <Menu MenuItem={homeMenu} />
      <div className="padding-blk inner-page">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <PageTitle
                pageTitle="Bonding With Parents"
                breadEnd="Bonding With Parents"
                breadMid="Bonding With Parents"
              />
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12 text-box bonding-parents">
              <h4 className="color-red">Quintessential Assemblies</h4>
              <LazyLoad>
                {" "}
                <img
                  src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/bonding-with-parents.jpg"
                  className="float-end wid-500 m-2"
                  alt="lotus valley school gurgaon"
                />
              </LazyLoad>
              <p>
                Assemblies create a sense of community, they work as a unifying
                force and make all students feel that they are a part of the
                school community. The session 2016-17 began with some meaningful
                and vibrant assemblies. All students of classes IX to XII got an
                opportunity to showcase their talent. Here is a glimpse of all
                that unfolded on the stage in the month of April, May and July.
              </p>
              <p>
                Assemblies on a variety of themes were conducted. The stage was
                set on fire with the spectacular performances by children. Some
                very pertinent and relevant themes such as Self Awareness and
                Self Esteem, Critical and Creative Thinking, Bullying, Seven
                Habits of Highly Successful People and Intricacies of Mind were
                taken up by students of the senior grades. Grade IX students
                enthralled the audience with their informative and stimulating
                presentations on Bio Mimicry, Adolescence, Power of Words and
                Inter- Personal Relationships. The students performed short
                skits, gave speeches and included mellifluous song and dance
                performances in their presentations. News was an essential part
                of all the morning assemblies. This helped in making students
                aware of the important and critical happenings of the world
                around us. Every assembly was unique in itself. The concepts
                conveyed by the students were thought- provoking and stirring.
                These assemblies not only helped in creating awareness but also
                helped in building confidence, oratory and theatrical skills of
                all learners.
              </p>
              <h4 className="color-red">Coffee With Principal</h4>
              <p>
                For us at Lotus Valley International, Gurgaon, nothing is more
                precious than our learners and their guardians who have always
                shown paramount faith and support to help in making this temple
                of learning stand firm along with the tremendous effort of our
                assiduous Principal Mrs. Anita Malhotra.
              </p>
              <p>
                School provides a new environment to which a child soon gets
                accustomed .What is very important to note is that discipline
                and learning which was initially and exclusively the
                responsibility of the parents must now be shared between the
                parent and the school. As parents continue to play an important
                role in the life of the child it becomes necessary that they
                work hand in hand with the school.
              </p>
              <p>
                A tailor made schedule that we call ‘The Lotus Valley
                Repertoire’ encompasses programmes like Coffee Meet which was
                initiated this year with the view to hold class-wise interaction
                between parents and the Principal on issues pertaining to
                academics, strategies, plans, feedbacks etc. We aim to look
                forward to, what we call ‘Constructive Criticism’, thereby
                making our system most transparent. Out of a total of 85
                sections, coffee meet has been conducted with about 65 sections
                already, beginning from the pre-primary classes.
              </p>

              <h4 className="color-red">Face Time</h4>
              <p>
                Face time is yet another addition to our regular interactions
                with parents; it provides parents a window to peek into their
                wards curricular and co-curricular development, unfolding into a
                feedback sharing platform with the mentors. Each face time is
                followed by a fruitful and enriching coffee session. A healthy
                open dialogue and effective communication was very rewarding as
                the role of parents is always appreciated and valued by Lotus
                Valley, Gurgaon to reach its academic milestones.
              </p>
              <p>
                All parents are presented with beautiful mementos as a token of
                love.
              </p>

              <h4 className="color-red">Conversing At The Crossroads</h4>
              <p className="color-green">
                <b>
                  SPEAKERS: Ms SonyaAnand, Ms Mitashi, Ms Karanpreet and Ms
                  Sumiran
                </b>
              </p>
              <p>
                Adolescence is a period filled with monumental challenges. It’s
                not easy to walk on the road that leads from adolescence into
                adulthood; the path is paved with difficulties and obstacles.
                Because everyone has their own unique way of perceiving,
                understanding and interpreting the situations, teens often feel
                that they are not understood but only heard, they often feel
                that their parents don’t act, but only react.
              </p>
              <p>
                Keeping these concerns in mind an interactive session was
                conducted for the parents of Grade VIII students. The aim of the
                workshop was to enable, equip and empower the parents to be able
                to work with their kids through their issues and concerns. The
                focus of the workshop was to be able to bridge the gap between
                the parent and teen communication and also to enhance the
                relationship they share and make sure that the environment is
                nurturing for both the teens as well as the parents.
              </p>
              <p>
                “CROSSROADS” is a platform wherein all important entities in an
                adolescent’s environment can come together and work towards
                his/her holistic development and wellbeing. It is a point, a
                junction where important insights take birth. The aim of this
                workshop was to help parents to learn how to resolve teenage
                concerns, their mutual differences and identify the ways of
                tackling challenges. This workshop was organized for parents to
                be able to work closely with the child and serve as the primary
                source to deal with teenage issues. It also aimed at
                strengthening parents’ ability to communicate effectively with
                each other and to manage conflicts in a productive manner.
                Counselors facilitated parents who were seeking guidance and
                provided an overview pertaining to the parenting skills and
                child’s behavior. In this workshop, parents were divided into
                groups, given situations and encouraged and guided to give
                interventions for a few situations.
              </p>

              <h4 className="color-red">Open House</h4>
              <p>
                Open House is a platform for mentors and parents to discuss the
                academic and behavioural growth of the learners and find a way
                forward to bridge gaps, if any. Keeping in mind the increasing
                strength of school, this year the school introduced two sessions
                for each PTM to cater to first half of the class learners in the
                first session and the rest in the second. This practice has been
                quite successful as all parents get good time to talk to various
                teachers at length.
              </p>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};
export default Bondingwithparents;
